export default "__VITE_ASSET__BAG1jc98__"